module.exports = __webpack_public_path__ + "static/media/ic_pet5.7b58d919.png";